<!-- 列表操作项二次确认弹框 -->
<template lang="pug">
    div.confirm-dialog
        el-dialog(
            center
            :top="top"
            :width="`${dialogWidth}px`"
            :visible.sync="dialogVisible"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            :show-close="showClose"
            custom-class="confirm-dialog"
            @close="cancel"
        )
            div.confirm-dialog-content
                div.svg
                    svg-icon(
                        :icon-class="svgName"
                        className="svg-icon"
                    )
                div.title(v-if="operateName !== ''") {{ operateName }}
                div.text
                    //- 文案插槽
                    slot(name="text-desc")
            span(
                slot="footer"
                class="dialog-footer"
            )
                el-button(
                    v-if="hasCancelButton"
                    size="small"
                    round
                    @click="cancel"
                )
                    span.button-text {{ cancelButtonText }}
                el-button(
                    v-if="hasConfirmButton"
                    type="primary"
                    size="small"
                    round
                    :loading="buttonLoading"
                    @click="confirmSubmit"
                )
                    span.button-text {{ confirmButtonText }}
</template>
<script>
/**
     * 使用示例
     *  ConfirmDialog(
            @confirmSubmit="confirmSubmit"
            :hasCancelButton="true"
        )
            div(slot="text-desc") xxxxxx
     */
export default {
    name: 'ConfirmDialog',
    props: {
        // 是否显示右上角关闭按钮
        showClose: {
            type: Boolean,
            default() {
                return true;
            },
        },
        // 弹窗宽度
        dialogWidth: {
            type: Number,
            default() {
                return 410;
            },
        },
        // 是否显示取消按钮
        hasCancelButton: {
            type: Boolean,
            default() {
                return true;
            },
        },
        // 是否显示确认按钮
        hasConfirmButton: {
            type: Boolean,
            default() {
                return true;
            },
        },
        // 图标名
        svgName: {
            type: String,
            default() {
                return 'warning';
            },
        },
        // 操作名
        operateName: {
            type: String,
            default() {
                return '删除角色';
            },
        },
        // 确定按钮文案
        confirmButtonText: {
            type: String,
            default() {
                return '确定';
            },
        },
        // 取消按钮文案
        cancelButtonText: {
            type: String,
            default() {
                return '取消';
            },
        },
        // 距顶部距离
        top: {
            type: String,
            default() {
                return '35vh';
            },
        },
    },
    data() {
        return {
            dialogVisible: false,
            buttonLoading: false,
        };
    },
    methods: {
        // 确认操作事件
        confirmSubmit() {
            this.$emit('confirmSubmit');
        },
        // 取消
        cancel() {
            this.dialogVisible = false;
            this.$emit('cancel');
        },
    },
};
</script>
<style scoped lang="scss" type="text/scss">
    .confirm-dialog {
        &-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .title {
                margin-top: 5px;
                height: 25px;
                line-height: 25px;
                @include font_size(text_emphasize);
                font-weight: 600;
                @include font_color(text_color_base);
            }
            .text {
                width: 100%;
                line-height: 20px;
                @include font_size(text_main_content);
            }
            .svg-icon {
                width: 54px !important;
                height: 54px !important;
            }
        }
        .dialog-footer {
            padding: 10px 20px 10px;
            button {
                width: 110px;
                height: 32px;
            }
            button + button {
                margin-left: 45px;
            }
            .button-text {
                @include font_size(text_main_content);
            }
        }
    }
</style>
<style lang="scss" type="text/scss">
    .confirm-dialog {
        .el-dialog {
            border-radius: 4px !important;
        }
        .el-dialog__header {
            height: 10px !important;
            @include bg_color(color_base_white, !important);
            button i {
                @include font_color(color_base_gray7, !important);
            }
        }
        .el-dialog__body {
            padding-top: 0;
            padding-bottom: 10px;
        }
    }
</style>
